

































import { defineComponent, computed } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import ALink from '@/components/common/a-link/a-link.vue';
import ManuallyName from './manually-name.vue';
import LearnMore from '@/components/common/learn-more/index.vue';
import { PAYER_NAME_TYPE } from './types';
import { PropType } from 'vue';
import SkeletonBasic from '@/components/skeleton/basic.vue';

const name = 'ttam-creation-payer-name-compose';

export default defineComponent({
  name,
  components: { ALink, ManuallyName, LearnMore, SkeletonBasic },
  props: {
    defaultPayerName: {
      type: String,
      required: true,
      default: '',
    },
    payerName: {
      type: String,
      required: true,
      default: '',
    },
    payerNameType: {
      type: Number as PropType<PAYER_NAME_TYPE>,
      required: true,
      default: PAYER_NAME_TYPE.USE_DEFAULT,
    },
    accountCenterLink: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const payerType = computed({
      get: () => props.payerNameType || PAYER_NAME_TYPE.USE_DEFAULT,
      set: (typeValue: PAYER_NAME_TYPE) => ctx.emit('change-payer-name-type', typeValue),
    });

    const isManuallyMode = computed(() => payerType.value === PAYER_NAME_TYPE.USE_MANUALLY_INPUT);

    const getModeOptions = () => [
      {
        label: props.defaultPayerName,
        tag: i18n.t('payer_name_default_tag_text'),
        value: PAYER_NAME_TYPE.USE_DEFAULT,
      },
      {
        label: i18n.t('payer_name_manually_mode_label'),
        value: PAYER_NAME_TYPE.USE_MANUALLY_INPUT,
      },
    ];

    const changePayerName = (payerName: string) => ctx.emit('change-payer-name', payerName);

    const onPayerNameTypeChange = (type: PAYER_NAME_TYPE) => {
      if (type === PAYER_NAME_TYPE.USE_DEFAULT) {
        changePayerName(props.defaultPayerName);
      } else {
        changePayerName('');
      }
    };

    return {
      payerType,
      isManuallyMode,
      getModeOptions,
      changePayerName,
      onPayerNameTypeChange,
    };
  },
});
